declare namespace $ {

	export class $mol_icon_account_multiple_plus extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=plus.view.tree.d.ts.map